<div class="score-report">
  <button
    type="button"
    class="score-report__close"
    aria-label="Close"
    (click)="onClose()"
  >
    <mat-icon>close</mat-icon>
  </button>
  <div class="score-report__header">
    <span class="score-report__badge">{{ badgeLabel }}</span>
    <div class="score-report__heading">
      <p class="score-report__title">{{ headerTitle }}</p>
      <p class="score-report__subtitle">Powered by Yukka</p>
    </div>
  </div>

  <app-report-overview [bullets]="bullets"></app-report-overview>

  <div class="score-report__tabs" role="tablist">
    <button
      id="report-tab-get-now"
      type="button"
      role="tab"
      class="score-report__tab"
      [class.score-report__tab--active]="activeMode === 'get_now'"
      (click)="setMode('get_now')"
    >
      Get now
    </button>
    <button
      id="report-tab-recurring"
      type="button"
      role="tab"
      class="score-report__tab"
      [class.score-report__tab--active]="activeMode === 'recurring'"
      (click)="setMode('recurring')"
    >
      Recurring
    </button>
  </div>

  <ng-template #scoreTypeField let-fieldId="fieldId">
    <div class="score-report__field" *ngIf="data.scoreTypeOptions?.length">
      <label class="score-report__field-label" [attr.for]="fieldId">
        Score type
      </label>
      <mat-form-field
        appearance="outline"
        class="score-report__select"
        floatLabel="never"
      >
        <mat-select
          [id]="fieldId"
          [value]="selectedReportType"
          (selectionChange)="onScoreTypeChange($event.value)"
          panelClass="score-report__select-panel"
          disableOptionCentering
        >
          <ng-container
            *ngIf="data.scoreTypeOptions?.length; else singleOption"
          >
            <mat-option
              *ngFor="let option of data.scoreTypeOptions"
              [id]="'report-score-type-option-' + option.value"
              [value]="option.value"
            >
              {{ option.label }}
            </mat-option>
          </ng-container>
          <ng-template #singleOption>
            <mat-option [value]="selectedReportType">
              {{ data.titleLine2 }}
            </mat-option>
          </ng-template>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-template>

  <ng-template #recipientsField let-fieldId="fieldId">
    <div class="score-report__field">
      <label class="score-report__field-label" [attr.for]="fieldId">
        Additional recipients
        <span class="score-report__field-optional">(optional)</span>
      </label>
      <input
        [id]="fieldId"
        type="text"
        class="score-report__text-input"
        placeholder="Add emails, comma-separated"
        [(ngModel)]="recipientsInput"
      />
    </div>
  </ng-template>

  <ng-container *ngIf="activeMode === 'get_now'">
    <ng-container
      *ngTemplateOutlet="
        scoreTypeField;
        context: { fieldId: 'score-type-select' }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        recipientsField;
        context: { fieldId: 'get-now-recipients' }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="activeMode === 'recurring'">
    <div class="score-report__field">
      <div class="score-report__field-label-row">
        <span class="score-report__field-label">Frequency:</span>
        <span class="score-report__field-hint">{{
          currentFrequency.hint
        }}</span>
      </div>
      <app-segmented-tabs
        id="report-frequency"
        idPrefix="report-frequency"
        [options]="frequencyOptions"
        [value]="frequency"
        (valueChange)="setFrequency($event)"
      ></app-segmented-tabs>
    </div>

    <ng-container
      *ngTemplateOutlet="
        scoreTypeField;
        context: { fieldId: 'schedule-score-type-select' }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        recipientsField;
        context: { fieldId: 'schedule-recipients' }
      "
    ></ng-container>
  </ng-container>

  <div class="score-report__disclaimer" *ngIf="showDisclaimer">
    <mat-icon class="score-report__disclaimer-icon">warning_amber</mat-icon>
    <span>{{ data.messageLine }}</span>
  </div>

  <div class="score-report__actions">
    <button
      id="report-preview-button"
      type="button"
      class="score-report__btn score-report__btn--ghost"
      [disabled]="!previewUrl"
      (click)="onExample()"
    >
      Example
    </button>
    <button
      *ngIf="activeMode === 'get_now'"
      id="report-download-button"
      type="button"
      class="score-report__btn score-report__btn--primary"
      [disabled]="downloadDisabled"
      [matTooltip]="downloadTooltip"
      (click)="onClick()"
    >
      <mat-spinner
        *ngIf="statusCheckLoading; else downloadIcon"
        diameter="16"
      ></mat-spinner>
      <ng-template #downloadIcon>
        <mat-icon class="score-report__btn-icon">file_download</mat-icon>
      </ng-template>
      <span>{{ statusCheckLoading ? 'Checking…' : 'Download report' }}</span>
    </button>
    <button
      *ngIf="activeMode === 'recurring'"
      id="report-confirm-schedule-button"
      type="button"
      class="score-report__btn score-report__btn--primary"
      [disabled]="!canSchedule"
      (click)="onConfirmSchedule()"
    >
      <mat-icon class="score-report__btn-icon">schedule</mat-icon>
      <span>Confirm schedule</span>
    </button>
  </div>
</div>
